import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "AiDesign"
});
const _hoisted_1 = {
  width: "29",
  height: "28",
  viewBox: "0 0 29 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M10.1138 6.375C10.1138 6.09886 10.3376 5.875 10.6138 5.875H13.6457C13.9218 5.875 14.1457 6.09886 14.1457 6.375V7.39097C14.1457 7.66711 13.9218 7.89097 13.6457 7.89097H10.6138C10.3376 7.89097 10.1138 7.66711 10.1138 7.39097V6.375Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.10577 7.125H7.08179C6.5295 7.125 6.08179 7.57271 6.08179 8.125V21.2447C6.08179 21.797 6.5295 22.2447 7.08179 22.2447H12.9384C13.3526 22.2447 13.7239 21.9894 13.8721 21.6027L16.2945 15.2844C16.4389 14.9078 16.8004 14.6592 17.2038 14.6592C17.7416 14.6592 18.1776 14.2232 18.1776 13.6854V8.125C18.1776 7.57272 17.7299 7.125 17.1776 7.125H15.1537V8.14695C15.1537 8.4231 14.9298 8.64695 14.6537 8.64695H9.60577C9.32963 8.64695 9.10577 8.4231 9.10577 8.14695V7.125ZM8.3479 10.9769C8.20983 10.9769 8.0979 11.0889 8.0979 11.2269V11.9869C8.0979 12.125 8.20983 12.2369 8.3479 12.2369H15.9118C16.0498 12.2369 16.1618 12.125 16.1618 11.9869V11.2269C16.1618 11.0889 16.0498 10.9769 15.9118 10.9769H8.3479ZM8.0979 13.9988C8.0979 13.8608 8.20983 13.7488 8.3479 13.7488H12.0039C12.142 13.7488 12.2539 13.8608 12.2539 13.9988V14.7588C12.2539 14.8969 12.142 15.0088 12.0039 15.0088H8.3479C8.20983 15.0088 8.0979 14.8969 8.0979 14.7588V13.9988Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M22.2631 15.7255H23.5094V22.328H22.2631V15.7255Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", {
  d: "M19.503 20.5775H16.7441L16.1161 22.328H14.8318L17.3054 15.7255H18.9798L21.4343 22.328H20.1119L19.503 20.5775ZM19.132 19.531L18.1901 16.8386H18.076L17.1151 19.531H19.132Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_6);
}
var AI_Design = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { AI_Design as default };
